export default [
    `
        <div>回首2020年资本市场，可谓好戏连台，截止12月23日，沪指年涨幅10.83%，创业板指数则大涨58.11%。而对个人投资者来说，把握好节奏，2020年也定是个丰收年。不过，在这样的行情下，2020年投资收益的分化应该是最大的！</div>
        <div>2021年即将到来，不以成败论英雄，再战新一年，如何去把握、看待新年新行情？这里，“道达号”先抛砖引玉，畅想欢聊四大话题！</div>
    `,
    `大盘已经连涨两年，2021年的行情还会继续火爆吗？散户炒股，赚钱才是王道，2021年究竟该如何提高胜率？达哥年度观点，一年只有这一次，错过无。`,
    `2020年，在新冠肺炎疫情的影响下，A股市场大幅震荡，不过结构性牛市特征明显。展望2021年，A股行情将如何演绎？板块机会又有哪些？来听庖哥对新一年的展望。`,
    `史诗般的2020年正在拉下帷幕，而充满期待的2021年，又会以怎样的方式迎接我们？如何才能规避掉“大涨不过两年”统计规律呢？`,
    `周线来看，沪指3500点一直无法攻克，该位置是过去几年的调整的颈线位压力位置，压力非常巨大。创业板也将面临前期高点。2021年市场怎样走呢？私募高手的技术测市或有你想不到的惊喜。`,
    `周线来看，沪指3500点一直无法攻克，该位置是过去几年的调整的颈线位压力位置，压力非常巨大。创业板也将面临前期高点。2021年市场怎样走呢？私募高手的技术测市或有你想不到的惊喜。`,
    `2021年，行业如何选择，在这里为您精选4大行业主线，抓住牛年不放松。`,
    `2021年，行业如何选择，在这里为您精选4大行业主线，抓住牛年不放松。`,
    `2021年，行业如何选择，在这里为您精选4大行业主线，抓住牛年不放松。`,
    `2021年，行业如何选择，在这里为您精选4大行业主线，抓住牛年不放松。`,
    `牛指十大价值公司，2020年，两家公司涨幅近200%，平均涨幅超过60%，2021年，又有哪些公司有幸进入牛指的“法眼”？`,
    `2019年外资增持最猛的10只A股，在2020年总体来说有很好的表现。而2020年外资增持最猛的10只A股也火热出炉，我们可以从这些公司揣摩出外资犀利的眼光！`
]